.picker {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-md, 16px);
  align-items: center;
}

.modeGroup {
  display: inline-flex;
  gap: var(--spacing-xs, 4px);
  flex-wrap: wrap;
}

.modeButton {
  padding: var(--spacing-xs, 4px) var(--spacing-sm, 8px);
  border: var(--border-width, 1px) solid var(--border-color, #ccc);
  background: transparent;
  cursor: pointer;
  border-radius: var(--radius-sm, 4px);
  min-height: 44px;
}

.modeButtonActive {
  composes: modeButton;
  border-color: var(--primary, #1976d2);
  background: var(--primary, #1976d2);
  color: var(--primary-contrast, #fff);
}

.tonicLabel {
  display: inline-flex;
  gap: var(--spacing-xs, 4px);
  align-items: center;
}

.tonicSelect {
  min-height: 44px;
  padding: var(--spacing-xs, 4px) var(--spacing-sm, 8px);
  border: var(--border-width, 1px) solid var(--border-color, #ccc);
  border-radius: var(--radius-sm, 4px);
  background: transparent;
}
